import { Button, Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useSettings } from "context/SettingsContext";
import { Formik } from "formik";
import { useEffect, useRef } from "react";
import ETiny from "components/editors/ETiny";
import Editor from "components/editors/Editor";
import InputPriceRate from "components/others/InputPriceRate";
import conf from "conf/conf";

const initValues = {
    amount:0,
    amountRate:0,
    description:''
}

const CardOtherFormik = ({setShowAddFormik, handleAddExpend}) => {

    const { t } = useTranslation(['Objects']);
    const { localSettings } = useSettings();
    const refInputAmount = useRef();
    const rate = Number(localSettings?.RATE?.current ?? 1) || 1;
    const TinyEditor = (conf.tinyMode ? ETiny : Editor);

    useEffect(()=>{
        if (refInputAmount.current) {
            refInputAmount.current.focus();
            refInputAmount.current.select();
        } 
    },[refInputAmount.current])
 
    return (
        <Formik initialValues={{...initValues}}
            onSubmit={async (values, {setSubmitting}) => {
                if (values.amount > 0) handleAddExpend(values);
                setShowAddFormik(false);
            }}>
        {({handleSubmit, isSubmitting, setFieldValue, values})=>(
            <Form className="px-3" 
                onSubmit={handleSubmit}>
                <h5 className="mb-3">{t('addExpend.btnAddExpend')}</h5>
                <Form.Group className="mb-3">
                    <label className="form-label text-muted">{t('addExpend.priceProduct')}</label>
                    <InputPriceRate
                        ref={refInputAmount}
                        allowNegative={false}
                        required
                        disabled={isSubmitting}
                        value={values.amount}
                        onValueChange={(val) => {
                            const base = Number(val?.floatValue) || 0;
                            setFieldValue('amount', base);
                            setFieldValue('amountRate', Number((base * rate).toFixed(2)));
                        }}/>
                </Form.Group>   

                <label className="form-label text-muted w-100 d-flex justify-content-between">
                    {t('addService.labelDescription')}</label>
                <TinyEditor 
                    value={values?.description||''}
                    onChange={(newValue)=>{
                        setFieldValue('description', newValue)
                }}/>


                <div className="text-end py-4">
                    <Button className="me-2"
                        onClick={()=>setShowAddFormik(false)}
                        size="sm"
                        variant="secondary">{t('common:buttons.cancel')}</Button>                    
                    <Button  
                        type="submit"
                        size="sm"
                        disabled={values.amount==0}
                        variant="primary">{t('common:buttons.save')}</Button>
                </div>
            </Form>)}

        </Formik>)
}

export default CardOtherFormik;